import Paperplane from './Paperplane';
import Dots from './Dots';

const Loading = {
  Paperplane,
  Dots
}

export default Loading;